"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIcon = getIcon;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styled = require("./styled");

var CourierIcon = function CourierIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#9121c2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.766 15.352c.105-.106.148-.274.105-.422C34.391 6.5 27.043.086 18.168.086 8.195.086.128 8.196.211 18.168.273 27.848 8.449 35.98 18.129 36c8.215.02 15.16-5.484 17.32-13.004.086-.254-.062-.527-.316-.633l-.742-.277a9.818 9.818 0 0 0-8.641 1.02c-1.164.761-2.031 1.394-2.031 1.394a9.041 9.041 0 0 1-5.125 1.566c-5.063 0-8.621-4.128-9.172-9.168l-.402-2.753a2.393 2.393 0 0 0-1.48-1.864L6.5 11.88a.279.279 0 0 1-.125-.445c4.34-5.801 9.633-4.532 9.633-4.532.953.086 1.738.446 2.375.871.953.657 1.672 1.586 2.137 2.645a10.573 10.573 0 0 0 9.718 6.355c.024 0 4.153.168 5.528-1.421zm0 0"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.246 11.012a1.038 1.038 0 1 0-.005-2.076 1.038 1.038 0 0 0 .005 2.076zm.231 5.484c.253 1.633 1.546 6.797 7.285 7.75.086.024.129-.105.043-.148-1.336-.614-4.809-2.625-7.2-7.664-.023-.043-.148-.024-.128.062zm0 0"
  })));
};

CourierIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40"
};
var StyledIcon = (0, _styledComponents["default"])(CourierIcon).withConfig({
  displayName: "helpers__StyledIcon",
  componentId: "sc-6qul3n-0"
})(_styled.iconStyles);

function getIcon(icon) {
  if (icon === false) {
    return;
  }

  if (icon && typeof icon === "string") {
    // eslint-disable-next-line react/display-name
    return function (props) {
      return /*#__PURE__*/_react["default"].createElement(_styled.Icon, (0, _extends2["default"])({
        src: icon
      }, props));
    };
  }

  return StyledIcon;
}